/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_ErrorInputs */

const en_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview unavailable. The file can still be downloaded.`)
};

const ar_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعاينة غير متاحة. يمكنك تنزيل الملف رغم ذلك.`)
};

const bn_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রিভিউ পাওয়া যাচ্ছে না। ফাইলটি এখনও ডাউনলোড করা যাবে।`)
};

const de_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau nicht verfügbar. Die Datei kann trotzdem heruntergeladen werden.`)
};

const es_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa no disponible. Aun así puedes descargar el archivo.`)
};

const fr_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu indisponible. Le fichier reste téléchargeable.`)
};

const pt_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévia indisponível. Mesmo assim, o arquivo pode ser baixado.`)
};

const zh_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览不可用。文件仍可下载。`)
};

const tr_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önizleme kullanılamıyor. Dosyayı yine de indirebilirsiniz.`)
};

const ru_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпросмотр недоступен. Файл всё равно можно скачать.`)
};

const pl_image_inspector_error = /** @type {(inputs: Image_Inspector_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podgląd niedostępny. Plik nadal można pobrać.`)
};

/**
* | output |
* | --- |
* | "Preview unavailable. The file can still be downloaded." |
*
* @param {Image_Inspector_ErrorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_error = /** @type {((inputs?: Image_Inspector_ErrorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_ErrorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_error(inputs)
	if (locale === "bn") return bn_image_inspector_error(inputs)
	if (locale === "de") return de_image_inspector_error(inputs)
	if (locale === "es") return es_image_inspector_error(inputs)
	if (locale === "fr") return fr_image_inspector_error(inputs)
	if (locale === "pt") return pt_image_inspector_error(inputs)
	if (locale === "zh") return zh_image_inspector_error(inputs)
	if (locale === "tr") return tr_image_inspector_error(inputs)
	if (locale === "ru") return ru_image_inspector_error(inputs)
	if (locale === "pl") return pl_image_inspector_error(inputs)
	return en_image_inspector_error(inputs)
});